












// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import Edit from '@/components/administration/activity/edit/EditContent.vue'
import { getDefaultAloActivity, AloActivity } from '@/models/alo/AloActivity';
import { toStringDictionary } from '@/utils/groupBy';
import { AloPageContent, getDefaultAloPageContent } from '@/models/alo/AloPageContent';

@Component({
  name: 'ReadBaseSeo',    
   props: {
    pageContent:{      
      default:getDefaultAloPageContent()
    },
    loading:{
      type:Boolean,
      default:false
    }
  },
  components:{Edit}
})
export default class ReadBaseSeo extends Vue {
  private pageContent!:AloPageContent
  private loading!:boolean
}
